<template>
    <Keypress key-event="keydown" @success="keyDown" />
</template>

<script>
import Keypress from "vue-keypress";

export default {
  props: {
    startChar: {
      type: String,
      default: "*",
    },
    endChar: {
      type: String,
      default: "*",
    },
  },
  data() {
    return { barcode: "", isBarcodeScanning: false,};
  },
  components: {
    Keypress,
  },
  methods: {
     // eslint-disable-next-line no-unused-vars
    keyDown(response){
      if (event.key === "Shift") {
        return;
      } else if (
        event.key === this.startChar &&
        this.isBarcodeScanning === false
      ) {
        this.isBarcodeScanning = true;
        // this.$logger.debug(`isBarcodeScanning ${this.isBarcodeScanning}`);
      } else if (
        event.key === this.endChar &&
        this.isBarcodeScanning === true
      ) {
        this.isBarcodeScanning = false;
        // this.$logger.debug(`isBarcodeScanning ${this.isBarcodeScanning}`);
        this.$emit("barcodeScanned", this.barcode);
        this.barcode = "";
      } else {
        if (this.isBarcodeScanning) {
          this.barcode += event.key;
          // eslint-disable-next-line no-console
          // this.$logger.debug(`this.barcode ${this.barcode}`);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
